import setupValidation from '@frontend/forms/validator';
import { toKebabCase } from '@frontend/util/text';
import { getParams } from '@frontend/util/url';
import $ from 'jquery';
import { getCurrentNavigationTab } from './utils';

const setupValidationUI = ($form) => {
  $form.parsley({
    successClass: 'input-success',
    errorClass: 'input-error',
    classHandler: el => el.$element.closest('.input-holder'),
    errorsWrapper: '<div class="error-feedback"></div>',
    errorTemplate: '<p class="error-message"></p>',
  });
};

const prefillForm = () => {
  if ($('#form19').length) {
    const currentSection = getCurrentNavigationTab(false);
    if (currentSection && currentSection.length) {
      const section = toKebabCase(currentSection.text().trim());
      const options = [...$('#field13 option')].filter(option => option.value).map(option => option.value);
      const foundItem = options.find(option => section.startsWith(option));
      if (foundItem) {
        $('#field13').val(foundItem);
      }
    }
  }
};

export const initPreFillEloquaFields = () => {
  const checkReferrer = () => {
    const utmSource = 'field15';
    const utmMedium = 'field16';
    const utmCampaign = 'field17';
    const ref = document.referrer;

    if (ref) {
      // eslint-disable-next-line no-unused-vars
      const checkIfEngine = ['google.com', 'bing.com', 'yahoo.com'].some(e => (ref.includes(e)
        ? $(`input[id='${utmMedium}']`).val('organic')
        : $(`input[id='${utmMedium}']`).val('referral')
      ));
      const refDomain = ref.match(/:\/\/(.[^/]+)/)[1];
      $(`input[id='${utmCampaign}']`).val('(not set)');
      $(`input[id='${utmSource}']`).val(`${refDomain}`);
    } else {
      $(`input[id='${utmSource}'], input[id='${utmCampaign}']`).val('(direct)');
      $(`input[id='${utmMedium}']`).val('(none)');
    }
  };

  $('[data-autopopulate]').each((index, el) => {
    el = $(el);
    const param = el.attr('data-autopopulate');
    const value = getParams()[param] || '';

    if (!value && !value.length) {
      checkReferrer();
    } else {
      el.val(value);
    }
  });
};

export default () => {
  prefillForm();
  setupValidation(setupValidationUI);
  initPreFillEloquaFields();
  const reqCheckboxes = $('.required-checkbox');
  reqCheckboxes.on('click', () => {
    const allChecked = reqCheckboxes.filter((i, a) => a.checked).length;
    const toggleSubmit = (reqCheckboxes.length !== allChecked);
    $('.btn-submit-toggle').prop('disabled', toggleSubmit);
  });
};



// WEBPACK FOOTER //
// ./src/static/js/contact-us.js